import { createSlice } from '@reduxjs/toolkit';

const FJSliceTimeLine = createSlice({
    name: 'timeLine',
    initialState: {
        currentTime: 0,
        totalTime: 10,

        // 容器宽度
        containerWidth: 0,
        // 时长于像素间的换算比例
        unitConversion: 1,
        // 最大缩放比例
        maxUnitConversion: 10,
        // 最小缩放比例
        minUnitConversion: 0.1,
        // 最小宽度缩放比例
        minWidthScale: 1 / 5,
        // 最大宽度缩放比例
        maxWidthScale: (1 / 6) * 30,
    },
    reducers: {
        setSliceCurrentTime: (state, action) => {
            state.currentTime = action.payload;
        },
        setSliceTotalTime: (state, action) => {
            state.totalTime = action.payload;
        },
        setSliceUnitConversion: (state, action) => {
            state.unitConversion = action.payload;
        },
        setSliceMaxUnitConversion: (state, action) => {
            state.maxUnitConversion = action.payload;
        },

        setSliceMinUnitConversion: (state, action) => {
            state.minUnitConversion = action.payload;
        },

        setSliceContainerWidth: (state, action) => {
            state.containerWidth = action.payload;
        },
    },
});

export const {
    setSliceCurrentTime,
    setSliceTotalTime,
    setSliceUnitConversion,
    setSliceMaxUnitConversion,
    setSliceMinUnitConversion,
    setSliceContainerWidth,
} = FJSliceTimeLine.actions;

export default FJSliceTimeLine.reducer;
